"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const THREE = __importStar(require("three"));
const gsap_1 = require("gsap");
const EventDispatcher_1 = __importDefault(require("./EventDispatcher"));
const Detect_1 = require("./Detect");
class Indicator extends EventDispatcher_1.default {
    constructor(isShowText) {
        super();
        this.clickEvent = { type: 'click-indicator' };
        this.position = new THREE.Vector3();
        this.vertex = new THREE.Vector3();
        this.offset = new THREE.Vector3();
        this.$dom = document.createElement('div');
        this.$text = null;
        this.group = null;
        this.text = Detect_1.isMobileDevice() ? 'TOUCH' : 'CLICK';
        this.clickHandler = this._click.bind(this);
        this._createDom(isShowText);
        this._addEvent();
    }
    update(widthHalf, heightHalf, camera) {
        this.vertex.copy(this.position);
        if (this.offset) {
            this.vertex.add(this.offset);
        }
        const pos = this.vertex.project(camera);
        const x = pos.x * widthHalf + widthHalf;
        const y = -(pos.y * heightHalf) + heightHalf;
        gsap_1.gsap.set(this.$dom, { x: x, y: y });
    }
    fadeOut(timer, cb) {
        gsap_1.gsap.to(this.group, {
            duration: timer,
            scaleX: 0.1,
            scaleY: 0.1,
            opacity: 0,
            ease: 'power2.inOut',
            onComplete: () => {
                cb();
            },
        });
    }
    getDom() {
        return this.$dom;
    }
    setPosition(position, offset) {
        this.position = position.clone();
        this.offset = offset;
    }
    setColor(color) {
        if (!color)
            return;
        this.$dom.classList.add('black');
    }
    _click() {
        this._removeEvent();
        this.dispatchEvent(this.clickEvent);
    }
    _addEvent() {
        this.$dom.addEventListener('click', this.clickHandler);
    }
    _removeEvent() {
        this.$dom.removeEventListener('click', this.clickHandler);
    }
    _createDom(isShowText) {
        this.$dom.className = 'indicator';
        this.group = document.createElement('div');
        this.group.className = 'group';
        this.$dom.appendChild(this.group);
        const circle = document.createElement('div');
        circle.className = 'circle circle-0';
        this.group.appendChild(circle);
        const circle1 = document.createElement('div');
        circle1.className = 'circle circle-1';
        this.group.appendChild(circle1);
        const circle2 = document.createElement('div');
        circle2.className = 'circle circle-2';
        this.group.appendChild(circle2);
        const center = document.createElement('div');
        center.className = 'center';
        this.group.appendChild(center);
        this.$text = document.createElement('span');
        this.$text.className = 'text';
        if (isShowText) {
            this.$text.innerText = this.text;
        }
        this.$dom.appendChild(this.$text);
    }
}
exports.default = Indicator;
